export const NoteStatusCodes = {
  active: 'ACTIVE',
  draft: 'DRAFT',
  deleted: 'DELETED',
  closed: 'CLOSED'
};
